import type React from 'react'
import { forwardRef } from 'react'

type CircleCheckIconProps = React.SVGProps<SVGSVGElement> & {
  strokeColor?: string
  fillColor?: string
  width?: number
  height?: number
}

const CircleCheckIcon = forwardRef<SVGSVGElement, CircleCheckIconProps>(
  ({ strokeColor = '#2482D8', fillColor = 'none', width = 24, height = 24, ...props }, ref) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke={strokeColor ? strokeColor : '#2DCA73'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default CircleCheckIcon
